import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import {
  Search,
  SearchIconWrapper,
  StyledInputBase,
} from "../../common/SearchBar";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";

export const SitesSearchBarAddCalendar = ({
  setSitesSearchString,
}: {
  setSitesSearchString: Dispatcher<string>;
}) => {
  return (
    <Search sx={{ border: "1px solid #E0E0E0", borderRadius: "5px" }}>
      <SearchIconWrapper>
        <SearchIcon />
      </SearchIconWrapper>
      <StyledInputBase
        // placeholder="Search Calendar Names"
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          setSitesSearchString(event.target.value)
        }
        inputProps={{ "aria-label": "search" }}
      />
    </Search>
  );
};
